
import * as Actions from './actions.js'

export const initialState = {
  error: false,
  loading: true,
  vitals: {}
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.VITALS:
      return {
        ...initialState,
        loading: true,
        vitals: {}
      }
    case Actions.VITALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        vitals: action.vitals
      }
    case Actions.VITALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        vitals: action.vitals
      }
    default:
      return state
  }
}
